import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-failmodal',
  templateUrl: './failmodal.component.html',
  styleUrls: ['./failmodal.component.css']
})
export class FailmodalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    if (sessionStorage.getItem("wrong_image")) 
    {
      document.getElementById('fail').style.display = 'block';
      sessionStorage.removeItem("wrong_image")
    } 
    else if (sessionStorage.getItem("transaction_refused")) 
    {
      document.getElementById('transaction_refused').style.display = 'block';
      sessionStorage.removeItem("transaction_refused")
    }
    else if (sessionStorage.getItem("TIME_OUT")) 
    {
      document.getElementById('TIME_OUT').style.display = 'block';
      sessionStorage.removeItem("TIME_OUT")
    }

    else if (sessionStorage.getItem("wrong_image_auth")) 
    {
      document.getElementById('wrong_auth').style.display = 'block';
      sessionStorage.removeItem("wrong_image_auth")
    } 
    else if (sessionStorage.getItem("transaction_refused_auth")) 
    {
      document.getElementById('transaction_refused_auth').style.display = 'block';
      sessionStorage.removeItem("transaction_refused_auth")
    }
    else if (sessionStorage.getItem("TIME_OUT_auth")) 
    {
      document.getElementById('TIME_OUT_auth').style.display = 'block';
      sessionStorage.removeItem("TIME_OUT_auth")
    }

  }

}
